import React from 'react';
import Text from '../../../../Components/Base/Text/Text';
// @ts-ignore
import styles from '../../../../Components/HealthPlan/PlanTimeline/PlanTimeline.module.scss';
import PlanTimelineColumn from '../../../../Components/HealthPlan/PlanTimeline/PlanTimelineColumn';
import PlanTimelineLegend from '../../../../Components/HealthPlan/PlanTimeline/PlanTimelineLegend';
import { HealthPlanTimelineGroup } from '../../../../Models/HealthPlan/HealthPlanTimelineGroup';

interface HealthPlanBabyTimelineProps {
	data: HealthPlanTimelineGroup[];
	onMonthClick?: (item: HealthPlanTimelineGroup) => void;
	patientId: string;
	healthPlanUser: any;
	workplaceId: string;
	reloadData: () => void;
}

const HealthPlanBabyTimeline: React.FC<HealthPlanBabyTimelineProps> = ({
	data,
	healthPlanUser,
	reloadData,
	workplaceId,
	patientId,
	onMonthClick,
}) => {
	const renderColumn = (column: HealthPlanTimelineGroup, index: number) => (
		<React.Fragment key={index}>
			<PlanTimelineColumn
				data={column}
				healthPlanUser={healthPlanUser}
				reloadData={reloadData}
				workplaceId={workplaceId}
				patientId={patientId}
				allowEdit
				onTitleClick={(item: HealthPlanTimelineGroup) => onMonthClick?.(item)}
			/>
		</React.Fragment>
	);

	return (
		<div>
			<div className={styles.wrapper}>
				<div className={'d-flex flex-row justify-content-between'}>
					<PlanTimelineLegend />
				</div>
				<div className={styles.timelineWrapper}>
					<div className={styles.timelinePart}>
						<Text
							tx='component.healthPlanBabyTimeline.motherCareScheme'
							className={styles.columnsTitle}
						/>
						<div className={styles.timeline}>
							{data
								.filter(({ month }) => month < 11)
								.map((column, index) => renderColumn(column, index))}
						</div>
					</div>
				</div>
				<Text
					className={styles.description}
					tx={'diabetes.healthPlan.individualize'}
				/>
			</div>
		</div>
	);
};

export default HealthPlanBabyTimeline;
